export default class AjaxData {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.$items = $wrapper.querySelectorAll('[data-ajax-load]');

        this.updateDom = this.updateDom.bind(this);
        this.fetchAjaxDate = this.fetchAjaxDate.bind(this);
        this.getUrl = this.getUrl.bind(this);
        this.fetch = this.fetch.bind(this);
    }

    updateDom() {
        this.$items.forEach((item) => this.fetchAjaxDate(item));
    }

    async fetchAjaxDate(item) {
        const result = await this.fetch(item);

        if(result) {
            const el = (new DOMParser()).parseFromString(result, "text/html").body.firstChild;
            item.parentNode.replaceChild(el, item);

            window.initDom(el.parentNode);
        } else {
            //console.log('No html delivered for', item.dataset)
        }
    }

    getUrl(item) {
        if ( ! item.dataset.type) {
            throw new Error('data-type attribute is missing for:' + item);
            return;
        }

        let url =  placeholders.baseUri ?
                placeholders.baseUri + '/ajax-data/account/' + item.dataset.type:
                '/ajax-data/account/' + item.dataset.type;

        let params = new URLSearchParams();

        Object.keys(item.dataset).forEach((key) => {
            if (key !== 'type') {
                params.set(key, item.dataset[key]);
            }
        });

        return url + '?' + params.toString();
    }

    async fetch(item) {
        try {
            const request = await fetch(
                    this.getUrl(item),
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'text/html',
                            'Content-Type': 'application/json'
                        },
                    }
            );

            // if something when't wrong
            if (!request.ok)  {
                // we throw the error of the request
                throw request.status;
            }

            return await request.text();
        } catch (e) {
            console.log(e);
            item.remove();
        }
    }
}